import { useEffect, useState } from "react";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { makeStyles, withStyles } from "@material-ui/styles";
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import purple from '@material-ui/core/colors/purple';
import yellow from '@material-ui/core/colors/yellow';

import ReactDice from 'react-dice-complete'
import 'react-dice-complete/dist/react-dice-complete.css'

import { CELL_INFO, CELLS_ORDER, CELL_TYPE, DEFAULT_PLAYERS } from "./settings";

const useModalStyles = makeStyles((theme)=>({
  default: {

  },
  visited: {
    backgroundColor: grey[400],
  },
  Kuis: {
    backgroundColor: blue[100],
  },
  Challenge: {
    backgroundColor: green[400],
  },
  Ayat: {
    backgroundColor: purple[200],
  },
}));

const ModalPaper = withStyles((theme) => ({
  root: {
    padding: 50,
    textAlign: "center",
    borderRadius: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}))(Paper);

const cellVisited = new Array(100+1);

function getModalClass(id) {
  const info = CELL_INFO[id];
  //return (info !== undefined && cellVisited[id]) ? "visited" : (info === undefined) ? "default" : info.type;
  return (info === undefined) ? "default" : info.type;
}

function PlayerEmblem(props){
  return (
    <Avatar style={{width: "20px", height: "20px", backgroundColor: "white", color: props.color}}>
      {props.id}
    </Avatar>
  );
}

function CellModal(props) {
  const info = CELL_INFO[props.id];
  const [expanded, setExpanded] = useState(false);
  const classes = useModalStyles();

  const handleChange = () => {
    setExpanded(!expanded);
  };

  const goldStyle = {
    backgroundColor: yellow[500],
  };

  const style = (info && info.type === "Golden Ticket" ? goldStyle : {});

  return (
    <ModalPaper style={style} className={classes[getModalClass(props.id)]}>
      <Typography style={{position: "absolute", top: 20, left: 30}} variant="subtitle1" color="textSecondary">
        {props.id}
      </Typography>

      {info !== undefined && (<>
        <Typography variant="h5">
          {info.type}
        </Typography>
        <Typography style={{marginTop: "10px", marginBottom: "10px"}} variant="h4">
          {info.text}
        </Typography>

        {info.answer && (<>
          <ButtonBase style={{marginTop: "20px", marginBottom: "10px", borderRadius: 0}} onClick={handleChange}>
            <Typography variant="body2">
              {expanded ? "Sembunyikan jawaban" : "Lihat jawaban"}
            </Typography>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </ButtonBase>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Typography paragraph>
              {info.answer}
            </Typography>
          </Collapse>
        </>)}

        {info.type === "Ayat" && (<>
          <Typography variant="body1">
            {info.description}
          </Typography>
        </>)}
      </>)}

      {(info === undefined) && (
        // Fallback
        <>
          <Typography variant="h6">
            Lanjutkan perjalananmu!
          </Typography>
          <Typography variant="body1">
            Anda masih beruntung (xixixi...)
          </Typography>
        </>
      )}
    </ModalPaper>
  );
}

function App(props) {
  const [open, setOpen] = useState(false);
  const [modal_id, setModalID] = useState(1);
  const numOfPlayer = props.numOfPlayer;
  const [players, setPlayers] = useState(DEFAULT_PLAYERS.slice(0, numOfPlayer));
  const [turn, setTurn] = useState(0);
  const [justRoll, setJustRoll] = useState(false);
  const [isRolling, setIsRolling] = useState(false);
  

  useEffect(() => checkCellType());

  const handleOpen = (id) => {
    setModalID(id);
    setOpen(true);
  };

  const handleClose = (id) => {
    cellVisited[modal_id] = true;
    setOpen(false);
  };

  const handleRollDone = (num) => {
    movePlayer(num);
    setJustRoll(true);
    setIsRolling(false);
  }

  const checkCellType = () => {
    if(!justRoll) return;
    const info = CELL_INFO[players[turn].pos];
    const goldTicket = (info && info.type === "Golden Ticket");
    setPlayers((prevState) => {
      let player = prevState[turn];
      let newState = [...prevState]

      const cellType = CELL_TYPE[player.pos];
      if(cellType) newState[turn].pos = cellType.to;
      
      return newState;
    });
    setJustRoll(false);
    if(!goldTicket) updateTurn();
  }

  const movePlayer = (steps) => {
    setPlayers((prevState) => {
      let newState = [...prevState];
      newState[turn].pos += steps;
      return newState;
    });
  }

  const hasFinish = () => {
    // Return true if every player position is 100 and false otherwise
    let result = true;
    for(let i=0; i<numOfPlayer; i++){
      result = (result && playerFinish(i));
    }
    return result;
  }

  const playerFinish = (id) => {
    return players[id].pos === 100;
  }

  const updateTurn = () => {
    if (hasFinish()) return;
    let nextTurn = (turn + 1) % numOfPlayer;
    let counter = 0;
    while(counter <= numOfPlayer && playerFinish(nextTurn)){
      nextTurn = (nextTurn + 1) % numOfPlayer;
      counter++;
    }
    setTurn(nextTurn);
  }

  var dice;

  const rollAll = () => {
    setIsRolling(true)
    dice.rollAll();
  }

  const cellSize = 47;

  return (
    <Grid style={{width: "100%", height:"100%"}} container direction="row" justifyContent="center" alignItems="center" spacing={10}>
      <Grid item>
        <Grid style={{width: "100%", height: "100%"}} container direction="column" alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="body1">
              {hasFinish() ? "Selesai" : `Giliran: ${players[turn].name}`}
            </Typography>
          </Grid>
          <Grid item>
            <ReactDice
              numDice={1}
              dotColor="#222222"
              faceColor="#eeeeee"
              rollDone={handleRollDone}
              ref={(given_dice) => {dice = given_dice}}
              disableIndividual={true}
            />
          </Grid>
          <Grid item>  
            <Button color="secondary" disabled={isRolling || justRoll || hasFinish()} onClick={updateTurn}>
              Skip
            </Button>
            <Button color="primary" variant="contained" disabled={isRolling || justRoll || hasFinish()} onClick={rollAll}>
              Acak dadu!
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid style={{marginTop: "50px"}} item direction="column" alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="subtitle2" align="center" color="textSecondary">
            CUBE Games
          </Typography>
          <Typography gutterBottom variant="h4" align="center">
            Ular Tangga Kehidupan
          </Typography>
          <Divider light />
        </Grid>
        <Box style={{backgroundImage: "url('/board.jpg')", backgroundSize: "cover", height: `${cellSize*10}px`, width: `${cellSize*10}px`}} mt={4} item component={Grid} container alignItems="center" justifyContent="center">
          {CELLS_ORDER.map((row, y)=>(
            <Grid item container alignItems="center" justifyContent="center">
              {row.map((id, x)=>(
                <Grid
                  container
                  component={ButtonBase}
                  //className={modalClasses[getModalClass(id)]}
                  style={{height: `${cellSize}px`, width: `${cellSize}px`}}
                  onClick={() => handleOpen(id)}
                >
                 {players.map((player)=>{
                  if(player.pos === id) return (
                    <Grid item>
                      <PlayerEmblem {...player} />
                    </Grid>
                  );
                  return null; 
                  })}
                </Grid>
              ))}
            </Grid>
          ))}
        </Box>
        <Box component={Grid} container alignItems="center" justifyContent="center">
          <Grid item>
            <Modal open={open} onClose={handleClose}>
              <CellModal id={modal_id} />
            </Modal>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

function StartScreen() {
  const maxPlayer = DEFAULT_PLAYERS.length;
  const possibleNumOfPlayer = Array.from(Array(maxPlayer).keys());
  const [numOfPlayer, setNumOfPlayer] = useState(-1);

  function handleClick(num) {
    setNumOfPlayer(num);
  }

  return numOfPlayer === -1 ? (
    <Grid style={{marginTop: "100px" ,width: "100%", height: "100%"}} spacing={5} container direction="column" alignItems="center" justifyContent="center">
      <Grid item>
        <Typography align="center" variant="h4">
          Pilih jumlah pemain!
        </Typography>
      </Grid>
      <Grid item>
        {possibleNumOfPlayer.map((num)=>(
          <Button style={{border: "1px solid black", borderRadius: 0}} onClick={() => handleClick(num+1)}>
            <Typography variant="h6">
              {num + 1}
            </Typography>
          </Button>
        ))}
      </Grid>
    </Grid>
  ) : <App numOfPlayer={numOfPlayer} />
}

export default StartScreen;
